import { champPersoToAdapted } from "./champPersoAdapter";

export function pieceContenusToAdapted(items) {
  return items
    ? items.map((item) => {
        return pieceContenuToAdapted(item);
      })
    : null;
}

export function pieceContenuToAdapted(item) {
  //Resource
  return item
    ? {
        piece_contenu_piece_id: item.piece_id,
        piece_contenu_champ_perso: champPersoToAdapted(item.champ_perso),
        piece_contenu_valeur: item.valeur,
      }
    : null;
}

export function adaptedToPieceContenu(item) {
  //Model
  return item ?
    {
      piece_id: item.piece_contenu_piece_id,
      champ_perso_id: item.piece_contenu_champ_perso_id,
      valeur: item.piece_contenu_valeur,
    }
    : null;
}
